import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Search, Plus, Activity, CheckCircle2, Trash2 } from "lucide-react";

const TABS = [
  { key: "active", label: "ACTIVE", icon: Activity, color: "#E63946" },
  { key: "completed", label: "COMPLETED", icon: CheckCircle2, color: "#2A9D8F" },
  { key: "deleted", label: "DELETED", icon: Trash2, color: "#666666" },
];

export default function Orders() {
  const [tab, setTab] = useState("active");
  const [orders, setOrders] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/orders", { params: { status: tab } })
       .then((r) => setOrders(r.data || []))
       .catch(() => setOrders([]))
       .finally(() => setLoading(false));
  }, [tab]);

  const filtered = orders.filter((o) => {
    if (!q) return true;
    const s = q.toLowerCase();
    return (
      o.order_no.toLowerCase().includes(s) ||
      o.customer.name.toLowerCase().includes(s) ||
      o.customer.city.toLowerCase().includes(s) ||
      o.customer.agent.toLowerCase().includes(s) ||
      o.customer.phone.includes(s)
    );
  });

  return (
    <div data-testid="orders-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#E63946] font-bold mb-2">── LEDGER</div>
          <h1 className="font-heading font-black text-4xl tracking-tighter">ORDERS.</h1>
        </div>
        <div className="flex gap-3">
          <div className="relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2" />
            <input className="brut-input pl-9 min-w-[260px]" data-testid="orders-search"
                   placeholder="Search order, name, city, agent…"
                   value={q} onChange={(e) => setQ(e.target.value)} />
          </div>
          <Link to="/orders/new" className="brut-btn brut-btn-primary" data-testid="orders-new-btn">
            <Plus size={16} strokeWidth={3} /> NEW
          </Link>
        </div>
      </div>

      <div className="flex gap-3 mb-4">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`tab-${t.key}`}
            className={`brut-btn !py-2 text-xs ${tab === t.key ? "brut-btn-dark" : "brut-btn-secondary"}`}
          >
            <t.icon size={14} strokeWidth={3} style={{ color: tab === t.key ? "#fff" : t.color }} />
            {t.label}
          </button>
        ))}
      </div>

      <div className="brut-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0A0A] text-white">
            <tr className="text-left">
              <th className="px-4 py-3 text-xs uppercase tracking-wider">Order #</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">Customer</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">City</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">Agent</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">Qty</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">Amount</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">By</th>
              <th className="px-4 py-3 text-xs uppercase tracking-wider">Created</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan="8" className="px-4 py-10 text-center text-sm text-[#666] uppercase tracking-wider">Loading…</td></tr>
            )}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan="8" className="px-4 py-10 text-center text-sm text-[#666] uppercase tracking-wider">No {tab} orders</td></tr>
            )}
            {!loading && filtered.map((o) => (
              <tr key={o.id} className="border-b border-black/15 hover:bg-[#F4F4F0] cursor-pointer"
                  data-testid={`row-${o.order_no}`}
                  onClick={() => window.location.assign(`/orders/${o.id}`)}>
                <td className="px-4 py-3 font-bold">{o.order_no}</td>
                <td className="px-4 py-3">{o.customer.name}</td>
                <td className="px-4 py-3">{o.customer.city}</td>
                <td className="px-4 py-3">{o.customer.agent}</td>
                <td className="px-4 py-3 font-mono">{o.total_quantity}</td>
                <td className="px-4 py-3 font-mono font-bold">₹{Math.round(o.total_amount).toLocaleString("en-IN")}</td>
                <td className="px-4 py-3 text-xs">{o.created_by_name}</td>
                <td className="px-4 py-3 text-xs text-[#666]">{new Date(o.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
